import tw from "tailwind-styled-components";
const Tab = tw.div`
  flex
  justify-center
  items-center
  grow
  border
  border-white
  border-opacity-10
  rounded-md
  py-[6px]
  text-xs
  cursor-pointer



  ${({ $isSelected })=>$isSelected ? "bg-brand-primary bg-opacity-10 text-brand-primary hover:border-opacity-20" : "bg-grayscale-medium hover:border-opacity-30 text-white"}
  ${({ $isDimmed })=>$isDimmed ? "text-white text-opacity-20 hover:border-opacity-30" : "hover:border-opacity-30"}
`;
export default Tab;
